import type { MediaItemInterface } from '@hypercodestudio/basler-components';
import type { BvsCameraManifest, BvsCameraSceneSummary } from '~/types/bvs';

/**
 * Camera image the manifest ships per scene. It is the frame the simulation
 * starts on, so the PDP thumbnails and the simulation placeholder can show it
 * without fetching a scene shard.
 */
export function buildBvsScenePreviewMedia(
  manifest: BvsCameraManifest,
  scene: BvsCameraSceneSummary
): MediaItemInterface | undefined {
  const preview = scene.previewImage;
  const source = manifest.sources.find(
    (item) => item.datasetId === preview?.sourceDatasetId
  );
  if (!preview || !source) {
    return undefined;
  }

  return {
    type: 'image',
    content: {
      mimeType: 'image/webp',
      src: new URL(preview.path, `${source.baseUrl}/`).toString(),
      width: preview.width,
      height: preview.height,
      alt: `Simulated image from camera ${manifest.camera.label} for ${scene.label}`
    }
  };
}
